import { HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { AuthService } from '@service/auth/auth.service';
import {IS_FASTAPI_REQUEST} from '@app/http/fastapi-request.context';

const SESSION_HEADER = 'X-Openerp-Session-Id';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.context.get(IS_FASTAPI_REQUEST)) {
    return next(request.clone({withCredentials: true}));
  }
  if (request.headers.has(SESSION_HEADER)) {
    return next(request);
  }
  const injector = inject(Injector);
  const auth = injector.get(AuthService);
  const sessionId = auth.currentSessionId;
  if (!auth.isUserAuthenticated || !sessionId) {
    return next(request);
  }
  return next(
    request.clone({
      withCredentials: true,
      setHeaders: {
        [SESSION_HEADER]: sessionId,
      },
    })
  );
};
